/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

(function () {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const IN_STOCK_VALUE = '1';

  function syncAvailability(form) {
    if (!form) return;

    const availabilityInput = form.querySelector(
      `input[name="${AVAILABILITY_PARAM}"][value="${IN_STOCK_VALUE}"]`
    );

    if (!availabilityInput) {
      console.warn('[AutoAvailability] Availability input not found');
      return;
    }

    const checkedFilters = Array.from(
      form.querySelectorAll('input[name^="filter."]:checked')
    );

    const nonAvailabilityChecked = checkedFilters.filter(
      (input) => input.name !== AVAILABILITY_PARAM
    );

    const hasOtherFilters = nonAvailabilityChecked.length > 0;

    console.log('--- Sync ---');
    console.log('Checked filters:', checkedFilters.map(i => i.name));
    console.log('Non-availability checked:', nonAvailabilityChecked.map(i => i.name));
    console.log('hasOtherFilters =', hasOtherFilters);
    console.log('Availability checked =', availabilityInput.checked);

    // If other filters exist → ensure availability ON
    if (hasOtherFilters && !availabilityInput.checked) {
      console.log('Auto-checking In Stock');
      availabilityInput.checked = true;
      form.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    // If NO other filters and availability is the only one → turn OFF
    if (!hasOtherFilters && availabilityInput.checked) {
      console.log('Auto-unchecking In Stock');
      availabilityInput.checked = false;
      form.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    console.log('No change needed');
  }

  // When any filter changes
  document.addEventListener('change', function (e) {
    if (!e.target.name || !e.target.name.startsWith('filter.')) return;

    const form = e.target.closest('form');
    if (!form) return;

    setTimeout(() => syncAvailability(form), 0);
  });

  // After Shopify re-renders filters
  document.addEventListener('theme:filters:init', function () {
    const form = document.querySelector('form');
    if (!form) return;

    setTimeout(() => syncAvailability(form), 0);
  });
})();







/* ===== LOOK-BOOK DRAWER – DEBUG EDITION (safe-currency + img-click) == */
(function(){
  console.log('[Lookbook] init script evaluated');

  /* ---------- helpers ---------- */
  const $  =(s,c=document)=>c.querySelector(s);
  const $$ =(s,c=document)=>[...c.querySelectorAll(s)];

  /* money formatter */
  const fmt = (cents)=>{
    try{
      if (window.themeCurrency?.formatMoney)
        return themeCurrency.formatMoney(cents, theme.moneyFormat);
      if (window.Shopify?.formatMoney)
        return Shopify.formatMoney(cents, theme.moneyFormat);
    }catch(e){/* noop */}
    return (cents/100).toFixed(2);           // fallback "12.34"
  };

  const fetchProduct = h=>{
    console.log('[Lookbook] fetching',h);
    return fetch(`${theme.routes.root}products/${h}.js`).then(r=>r.json());
  };

  /* ---------- boot after DOM ---------- */
  const boot=()=>{
    if(!$('#lookbook-drawer')) return;
    document.addEventListener('click',globalClick,false);
    $('#lookbook-add-to-cart').addEventListener('click',addToCart,false);
    console.log('[Lookbook] listeners attached');
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);

  const refs=()=>({body:document.body,drawer:$('#lookbook-drawer'),overlay:$('#lookbook-overlay'),holder:$('#lookbook-products-holder')});

  /* ---------- click delegation ---------- */
  async function globalClick(e){
    const {overlay}=refs();
    if(e.target.closest('[data-lookbook-close]')||e.target===overlay){ closeDrawer(); return;}
    const trigger=e.target.closest('.lookbook-item');          // <<< whole item now
    if(!trigger) return;
    const combo=trigger.nextElementSibling;
    if(!combo){console.warn('[Lookbook] .combo-products missing');return;}
    const handles=combo.textContent.trim().split(/\s+/).filter(Boolean);
    console.log('[Lookbook] handles',handles);
    if(!handles.length) return;
    await buildDrawer(handles);
  }

  /* ---------- build / open ---------- */
  async function buildDrawer(handles){
    const {body,drawer,holder}=refs();
    body.classList.add('js-drawer-open-lookbook');
    drawer.setAttribute('aria-hidden','false');
    holder.innerHTML='<p style="padding:1rem">Loading…</p>';
    const cards=[];
    for(const h of handles){
      try{cards.push(await buildCard(await fetchProduct(h)));}catch(e){console.error(e);}
    }
    holder.innerHTML='';
    cards.forEach(c=>holder.appendChild(c));
    console.log('[Lookbook] drawer populated',cards.length);
  }

  async function buildCard(prod){
    const first=prod.variants.find(v=>v.available)||prod.variants[0];
    const wrap=document.createElement('div');
    wrap.className='lookbook-product';
    wrap.innerHTML=`
      <img class="lookbook-product__img" src="${prod.featured_image}" alt="${prod.title}">
      <div style="flex:1">
        <p class="lookbook-product__title">${prod.title}</p>
        <p class="lookbook-product__price">€ ${fmt(first.price)}</p>
        <div class="lookbook-variants">
          ${prod.variants.map(v=>`
             <label class="lookbook-variant ${v.available?'':'sold-out-variant'}">
               <input type="radio" name="var-${prod.id}" value="${v.id}" ${v.available?'':'disabled'}>
               <span>${v.title}</span>
             </label>`).join('')}
        </div>
        <label style="display:flex;align-items:center;gap:.25rem;margin-top:.5rem;">
          <input type="checkbox" class="lookbook-check"><span>Toevoegen</span>
        </label>
      </div>`;
    wrap.querySelector('input[type=radio]').checked=true;
    return wrap;
  }

  /* ---------- add to cart & close ---------- */
async function addToCart () {
  const {holder} = refs();
  const cards = $$('.lookbook-product', holder);

  for (const card of cards) {
    if (!$('.lookbook-check', card).checked) continue;
    const id = $('input[type=radio]:checked', card).value;
    await fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
  }

  /* 1 – close the look-book drawer */
  closeDrawer();

  /* 2 – force cart drawer to refresh its contents */
  if (window.cart && typeof window.cart.getCart === 'function') {
    await window.cart.getCart();         // fetch & rebuild cart markup
  }

  /* 3 – open cart drawer (it now contains the new items) */
  if (window.cart && typeof window.cart.openCartDrawer === 'function') {
    window.cart.openCartDrawer();
  } else {
    // Fallback: click on the drawer-toggle button if drawer logic isn't initialised yet
    document.querySelector('[data-cart-drawer-toggle]')?.click();
  }
}
  function closeDrawer(){
    const {body,drawer,holder}=refs();
    body.classList.remove('js-drawer-open-lookbook');
    drawer.setAttribute('aria-hidden','true');
    holder.innerHTML='';
  }
})();




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();